module.exports = __webpack_public_path__ + "static/media/arrow-down-white.75449c46.svg";